import React from 'react';
import styled from 'styled-components';

const ListItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;

  h3 {
    margin: 0;
  }

  .list-count {
    flex: 1;
    text-align: right;
  }
`;

interface ListItemCountProps {
  name: string;
  count: number;
  isHighlighted?: boolean;
}

const ListItemCount: React.FC<ListItemCountProps> = ({ name, count, isHighlighted = false }) => {
  return (
    <ListItemWrapper>
      <h3 className={isHighlighted ? 'text-primary' : 'text-default'}>
        {name}
      </h3>
      <div className='list-count text-muted'>{count}</div>
    </ListItemWrapper>
  );
};

export default ListItemCount;
